import {
  AddLockerStation,
  EditLockerStation,
  LockerStationDetail,
  ServiceAssociatedLocker,
} from "@admin/pages/locker-station";
import {
  BuildingNew,
  DeliveryConfigure,
  EntranceRecords,
  // ImportLocker,
  // LockerAdd,
  // LockerAssociate,
  // LockerDetail,
  ObjectDetail,
  ObjectEdit,
  ObjectList,
  ObjectNew,
  PassProvider,
} from "@admin/pages/objects-configure";
import type { RouteObject } from "react-router-dom";

export const lockerStationRoute = [
  { path: ":lockerStationId", element: <LockerStationDetail /> },
  { path: ":lockerStationId/edit", element: <EditLockerStation /> },
  { path: "create", element: <AddLockerStation /> },
] satisfies RouteObject[];

export const serviceRoute = [
  {
    path: "services",
    children: [
      { path: ":serviceId/associated-locker", element: <ServiceAssociatedLocker /> },
      { path: ":serviceId/delivery-setting", element: <DeliveryConfigure /> },
      { path: ":serviceId/pass-providers", element: <PassProvider /> },
    ],
  },
] satisfies RouteObject[];

const routes = [
  { index: true, element: <ObjectList /> },
  { path: "create", element: <ObjectNew /> },
  { path: "edit/:id", element: <ObjectEdit /> },
  { path: "create/:id", element: <BuildingNew /> },

  // { path: "import-locker/:id/:serviceName", element: <ImportLocker /> },
  { path: "entranceRecords/:id", element: <EntranceRecords /> },
  { path: "debugRecords/:id", element: <EntranceRecords /> },
  // { path: "lockerAdd", element: <LockerAdd /> },
  // { path: "locker-detail/:id", element: <LockerDetail /> },
  {
    path: ":id",
    children: [
      { index: true, element: <ObjectDetail /> },
      { path: "locker-stations", children: lockerStationRoute },
      ...serviceRoute,
    ],
  },
] as RouteObject[];

export const propertiesRoute = {
  path: "properties",
  children: routes,
} as RouteObject;
